import { cloudinaryLoader, getUpdatedItems } from 'functions';

import Image from 'next/image';
import NumberInput from 'Components/Form/number-input';
import SiteImage from 'Components/Common/SiteImage';
import { useState } from 'react';
import { v4 } from 'uuid';

export default function CartItem({
  item,
  products,
  updateCartProcessing,
  updateCart,
  handleRemoveProductClick
}) {
  const { image, name, qty, price, regularPrice, cartKey, onSale } = item;
  const [productCount, setProductCount] = useState(qty);

  const handleQuantityChange = (event, cartKey) => {
    if (process.browser) {
      if (updateCartProcessing) {
        return;
      }

      const newQty = event ? event : 1;
      setProductCount(newQty);

      if (products.length) {
        const updateItems = getUpdatedItems(products, newQty, cartKey);
        updateCart({
          variables: {
            input: {
              clientMutationId: v4(),
              items: updateItems
            }
          }
        });
      }
    }
  };

  return (
    <article className="cart-item-wrapper cart-section-item">
      <div className="px-2">
        <SiteImage
          width={100}
          height={100}
          src={image?.cloudinaryResource?.url_suffix || image?.sourceUrl}
          layout="intrinsic"
          alt={name}
          loader={image?.cloudinaryResource ? cloudinaryLoader : ''}
        />
      </div>
      <div className="item-info">
        <div className="product-name text-sm">{name}</div>
        <div className="product-price">
          <span
            className="font-medium text-red-500"
            dangerouslySetInnerHTML={{ __html: onSale ? price : regularPrice }}
          />
          {onSale && (
            <span
              className="text-xs text-slate-600 line-through"
              dangerouslySetInnerHTML={{ __html: regularPrice }}
            />
          )}
        </div>
        <div className="product-qty flex justify-between">
          <NumberInput
            min={0}
            value={productCount}
            onChange={(e) => handleQuantityChange(e, cartKey)}
          />
          <span
            className="cursor-pointer text-sm text-blue-600"
            onClick={(event) =>
              handleRemoveProductClick(event, item.cartKey, products)
            }
          >
            Xoá
          </span>
        </div>
      </div>
    </article>
  );
}
